var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "form-group" }, [
        _c("small", [
          _vm._v(_vm._s(_vm.$t("maintenance.inventory.stockTaking.model.name")))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.stockTaking.name,
              expression: "stockTaking.name"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "text", disabled: _vm.stockTaking.completedAt },
          domProps: { value: _vm.stockTaking.name },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.stockTaking, "name", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("small", [
          _vm._v(
            _vm._s(
              _vm.$t("maintenance.inventory.stockTaking.model.scheduledAt")
            )
          )
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.scheduledAt,
              expression: "scheduledAt"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "datetime-local",
            disabled: _vm.stockTaking.completedAt
          },
          domProps: { value: _vm.scheduledAt },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.scheduledAt = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn-group btn-group-sm mb-2",
          attrs: { "data-toggle": "buttons" }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              attrs: { type: "button" },
              on: { click: _vm.openSelectModal }
            },
            [_vm._v(_vm._s(_vm.$t("btnAdd")))]
          )
        ]
      ),
      _vm._v(" "),
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.stockTaking.entries,
          paginationOptions: _vm.paginationOptions,
          searchOptions: _vm.searchOptions
        },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "actions"
                  ? _c("div", { staticClass: "btn-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-danger",
                          on: {
                            click: function($event) {
                              return _vm.onEntryRemove(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash" })]
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n        "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("InventorySelectModal", {
        ref: "selectModal",
        on: { selected: _vm.onInventoriesSelected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }